export default "__VITE_ASSET__D1XlAN5W__"